import { RSAA } from 'redux-api-middleware';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';
import { toOptions } from '@/utils/Helpers';

const host = process.env.BACKEND_URL;
const entity = 'EXAMS';

export const FORM_NAME = `${entity}/FORM`;

export const WIN_PERCENT = 0.7;

// export const optionsUserCategory = [
//   { value: 'teacher', label: 'Для педагогов' },
//   { value: 'student', label: 'Для детей' },
// ];S

export const EXAM_NEW = 'new';
export const EXAM_IN_PROCESS = 'in_process';
export const EXAM_FINISHED = 'finished';
export const EXAM_ARCHIVE = 'archive';

export const STATUSES = {
  [EXAM_NEW]: 'Экзамен создан',
  [EXAM_IN_PROCESS]: 'Экзамен начат',
  [EXAM_FINISHED]: 'Экзамен завершен',
  [EXAM_ARCHIVE]: 'В архиве',
};

export const optionsStatuses = [
  { value: EXAM_NEW, label: STATUSES[EXAM_NEW] },
  { value: EXAM_IN_PROCESS, label: STATUSES[EXAM_IN_PROCESS] },
  { value: EXAM_FINISHED, label: STATUSES[EXAM_FINISHED] },
  { value: EXAM_ARCHIVE, label: STATUSES[EXAM_ARCHIVE] },
];
// sama - pama
export const abacusList = {
  '12': 'LEVEL_12',
  '11': 'LEVEL_11',
  '10': 'LEVEL_10',
  '9': 'LEVEL_9',
  '8': 'LEVEL_8',
  '7': 'LEVEL_7',
  '6': 'LEVEL_6',
  '5': 'LEVEL_5',
  '4': 'LEVEL_4',
  '3': 'LEVEL_3',
};

export const mentalList = {
  '10': 'LEVEL_10',
  '9': 'LEVEL_9',
  '8': 'LEVEL_8',
  '7': 'LEVEL_7',
  '6': 'LEVEL_6',
  '5': 'LEVEL_5',
  '4': 'LEVEL_4',
  '3': 'LEVEL_3',
  '2': 'LEVEL_2',
};
// uamap
export const studentList = {
  '13': 'LEVEL_13',
  '12': 'LEVEL_12',
  '11': 'LEVEL_11',
  '10': 'LEVEL_10',
  '9': 'LEVEL_9',
  '8': 'LEVEL_8',
  '7': 'LEVEL_7',
  '6': 'LEVEL_6',
};

export const teacherList = {
  '3': 'LEVEL_3',
  '2': 'LEVEL_2',
  '1': 'LEVEL_1',
};

const toLevelOptions = toOptions(([value, label]) => ({
  value,
  label: <FormattedMessage id={label} />,
}));

export const optionsSimulator = {
  sama: [
    {
      value: 'abacus',
      label: <FormattedMessage id="ABACUS_ARITHMETIC" />,
      levels: toLevelOptions(abacusList),
      roles: [1, 2, 3],
    },
    {
      value: 'mental',
      label: <FormattedMessage id="MENTAL_ARITHMETIC" />,
      levels: toLevelOptions(mentalList),
      roles: [1, 2, 3],
    },
  ],
  uamap: [
    {
      value: 'teacher',
      label: <FormattedMessage id="FOR_TEACHER" />,
      levels: toLevelOptions(teacherList),
      roles: [2, 3],
    },
    {
      value: 'student',
      label: <FormattedMessage id="FOR_CHILDREN" />,
      levels: toLevelOptions(studentList),
      roles: [1],
    },
  ],
};

export const optionsSertificationType = [
  {
    value: 'sama',
    label: 'PAMA GLOBAL',
    simulator: optionsSimulator.sama,
    title: 'CATEGORY',
  },
  {
    value: 'uamap',
    label: 'UAMAP',
    simulator: optionsSimulator.uamap,
    title: 'ROLE',
  },
];

export const optionsStatus = [
  {
    value: 'new',
    label: <FormattedMessage id="EXAM_NEW" />,
  },
  {
    value: 'finished',
    label: <FormattedMessage id="EXAM_FINISHED" />,
  },
  {
    value: 'in_progress',
    label: <FormattedMessage id="EXAM_IN_PROCESS" />,
  },
  {
    value: 'archive',
    label: <FormattedMessage id="EXAM_ARCHIVE" />,
  },
  {
    value: 'successful',
    label: <FormattedMessage id="EXAM_SUCCESSFUL" />,
  },
  {
    value: 'failure',
    label: <FormattedMessage id="EXAM_FAILURE" />,
  },
];

export const optionsPaid = [
  {
    value: 0,
    label: <FormattedMessage id="YES" />,
  },
  {
    value: 1,
    label: <FormattedMessage id="NO" />,
  },
];

// Init state
const initialState = {
  list: [],
  entity: {},
};

export const types = {
  SET_LIST: `${entity}/SET_LIST`,
  SET_ONE: `${entity}/SET_ONE`,
  REQUEST_LIST: `${entity}/REQUEST_LIST`,
  REQUEST_ONE: `${entity}/REQUEST_ONE`,
  REQUEST_CREATE: `${entity}/REQUEST_CREATE`,
  REQUEST_EDIT: `${entity}/REQUEST_EDIT`,
  REQUEST_EDIT_ONE: `${entity}/REQUEST_EDIT_ONE`,
  REQUEST_DELETE: `${entity}/REQUEST_DELETE`,
  REQUEST_LOAD_REPORT: `${entity}/REQUEST_LOAD_REPORT`,
  REQUEST_PARTICIPATE: `${entity}/REQUEST_PARTICIPATE`,
  REQUEST_LOAD_SAMA_REPORT: `${entity}/REQUEST_LOAD_SAMA_REPORT`,
  REQUEST_LOAD_CERTIFICATION: `${entity}/REQUEST_LOAD_CERTIFICATION`,
  REQUEST_CHECK_CERTIFICATION: `${entity}/REQUEST_CHECK_CERTIFICATION`,
};

// Reducer
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_LIST:
    case types.SET_ONE:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    default:
      return state;
  }
};

// Actions

export const fetchOne = id => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_ONE,
      },
    })),
  },
});

export const fetchParticipate = id => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/participate/${id}`,
    method: 'POST',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_PARTICIPATE,
      },
    })),
  },
});

export const fetchList = () => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_LIST,
      },
    })),
  },
});

export const fetchCreate = formData => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_CREATE,
      },
    })),
  },
});

export const fetchEdit = (id, formData) => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/${id}`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_EDIT,
      },
    })),
  },
});

export const fetchEditOne = (id, data) => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLowerCase()}/edit/${id}`,
    method: 'POST',
    body: JSON.stringify(data),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_EDIT_ONE,
      },
    })),
  },
});

export const fetchDelete = id => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_DELETE,
      },
    })),
  },
});

export const fetchLoadReport = formData => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/report`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_LOAD_REPORT,
      },
    })),
  },
});

export const fetchLoadSamaReport = formData => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/report_sama`,
    method: 'POST',
    body: JSON.stringify(formData),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_LOAD_SAMA_REPORT,
      },
    })),
  },
});

export const fetchLoadCertification = id => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/certification/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_LOAD_CERTIFICATION,
      },
    })),
  },
});

export const certificationCheck = code => ({
  [RSAA]: {
    endpoint: `${host}/${entity.toLocaleLowerCase()}/check/${code}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: types.REQUEST_CHECK_CERTIFICATION,
      },
    })),
  },
});

export const actions = {
  fetchList,
  fetchCreate,
  fetchEdit,
  fetchDelete,
  fetchOne,
  fetchLoadReport,
  fetchLoadSamaReport,
  certificationCheck,
  fetchLoadCertification,
  fetchParticipate,
  fetchEditOne,
};

export default reducer;
